import { ICauHoiProgressRequest } from "../../../model/request/cau-hoi/ICauHoiProgressRequest";
import { ITongHopCauHoiRequest } from "../../../model/request/cau-hoi/ITongHopCauHoiRequest";
import { ITongHopTheoDotRequest } from "../../../model/request/de-thi/ITongHopTheoDotRequest";
import { IProcessRequest } from "../../../model/request/IProcessRequest";
import { ISMT_Question_Answer } from "../../../model/respone/cau-hoi/ISMT_Question_Answer";
import { ITongHopCauHoiResponse } from "../../../model/respone/cau-hoi/ITongHopCauHoiResponse";
import { IPagingResult } from "../../../model/respone/IPagingResult";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
import { ICauHoiSelectRequest } from "./../../../model/request/cau-hoi/ICauHoiSelectRequest";

export const eCauHoiActionsObj = {
  LOAD_START: {} as ICauHoiSelectRequest,
  LOAD_SUCCESS: {} as IPagingResult<ISMT_Question_Answer[]>,
  LOAD_ERRR: "",

  SAVE_START: {} as any,
  SAVE_SUCCESS: {} as any,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  DELETES_START: [] as number[],
  DELETES_SUCCESS: undefined,
  DELETES_ERROR: "",

  SELECTED_ID: [] as number[],

  SHOW_EDIT_MODAL: {} as undefined | ISMT_Question_Answer,
  CLOSE_EDIT_MODAL: undefined,

  SHOW_VIEW_MODAL: {} as ISMT_Question_Answer,
  CLOSE_VIEW_MODAL: undefined,

  CHANGE_REQUEST: {} as any,

  IMPORT_WORD_CHANGE_REQUEST: {} as any,
  IMPORT_WORD_START: {} as IProcessRequest<FormData>,
  IMPORT_WORD_SUCCESS: undefined,
  IMPORT_WORD_ERROR: "",
  IMPORT_WORD_CLOSE_PROCESSING_MODAL: undefined,

  SHOW_UPLOAD_MODAL: undefined,
  CLOSE_UPLOAD_MODAL: undefined,

  IMPORT_FILE_START: {} as IProcessRequest<FormData>,
  IMPORT_FILE_SUCCESS: undefined,
  IMPORT_FILE_ERROR: "",
  CLOSE_ERROR_RESULT_IMPORT_MODAL: undefined,
  IMPORT_FILE_CLOSE_PROCESSING_MODAL: undefined,

  SHOW_UPLOAD_FILE_MODAL: undefined,
  CLOSE_UPLOAD_FILE_MODAL: undefined,

  CHECK_DUPLICATE_START: {} as any,
  CHECK_DUPLICATE_SUCCESS: {} as any,
  CHECK_DUPLICATE_ERROR: "",

  SHOW_DUPLICATE_MODAL: undefined,
  CLOSE_DUPLICATE_MODAL: undefined,

  SHOW_SEARCH_MODAL: undefined,
  CLOSE_SEARCH_MODAL: undefined,

  LOAD_TONGHOP_START: {} as ITongHopCauHoiRequest,
  LOAD_TONGHOP_SUCCESS: {} as ITongHopCauHoiResponse[],
  LOAD_TONGHOP_ERRR: "",

  EXPORT_TONGHOP_START: {} as ITongHopCauHoiRequest,
  EXPORT_TONGHOP_SUCCESS: undefined,
  EXPORT_TONGHOP_ERRR: "",

  PROGRESS_START: {} as ICauHoiProgressRequest,
  PROGRESS_SUCCESS: undefined,
  PROGRESS_ERRR: "",

  CHANGE_REQUEST_TONGHOP: {} as any,

  CHANGE_SU_DUNG_START: 0,
  CHANGE_SU_DUNG_SUCCESS: undefined,
  CHANGE_SU_DUNG_ERROR: "",
};
export const eCauHoiActionIds = generateActionTypeIds(
  eCauHoiActionsObj,
  "CAU_HOI",
);
export type ICauHoiActionTypes = IGenericActionType<
  typeof eCauHoiActionsObj,
  "CAU_HOI"
>;
